import Vue from 'vue'
import Vuex from 'vuex'
import session, { SessionState } from './modules/session'
import depositAccount from './modules/depositAccount'
import depositBankAccount from './modules/depositBankAccount'
import pages from './modules/pages'
import components from './modules/components'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export interface RootState {
  session: SessionState
  depositAccount: any
  depositBankAccount: any
  pages: any
  components: any
  referrer: string
}

export default new Vuex.Store<RootState>({
  // @ts-ignore
  namespaced: true,
  modules: {
    session,
    depositAccount,
    depositBankAccount,
    pages,
    components,
  },
  mutations: {
    referrer(state, value) {
      state.referrer = value
    },
  },
  strict: debug,
})
